import { jsxs, jsx } from "react/jsx-runtime";
const IconUndoSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M15.5 8H5.414l3.293-3.293a1 1 0 1 0-1.414-1.414L2.294 8.292a.998.998 0 0 0-.217 1.09c.05.123.124.234.217.326l4.999 4.999a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414L5.414 10H15.5c2.481 0 4.5 2.019 4.5 4.5S17.981 19 15.5 19a1 1 0 1 0 0 2c3.584 0 6.5-2.916 6.5-6.5S19.084 8 15.5 8Z" })
    ]
  }
);
export {
  IconUndoSvg
};
